import { render, staticRenderFns } from "./Spfail.vue?vue&type=template&id=46f85b82&scoped=true&"
import script from "./Spfail.vue?vue&type=script&lang=js&"
export * from "./Spfail.vue?vue&type=script&lang=js&"
import style0 from "./Spfail.vue?vue&type=style&index=0&id=46f85b82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f85b82",
  null
  
)

export default component.exports